/**
 * ENCAPTURE — PRODUCT CORE STABLE FINAL
 * Swatch → Variante → Media → Prezzo → Stock → Drawer
 * NO redirect al carrello - Protezione Airbag + Scroll Unlock attivi
 *
 * FILE: assets/product.js
 */

/* ---------------- VARIANT SELECTS ---------------- */

if (!customElements.get('variant-selects')) {
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
        return;
      }

      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateVariantLabels();
    }

    updateOptions() {
      this.options = Array.from(
        this.querySelectorAll('select, input:checked'),
        (el) => el.value
      );
    }

    updateMasterId() {
      this.variantData =
        this.variantData ||
        JSON.parse(this.querySelector('[type="application/json"]').textContent);

      this.currentVariant = this.variantData.find((variant) => {
        return !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(false);
      });
    }

    updateVariantInput() {
      const sectionId = this.dataset.section;
      const form = document.getElementById(`product-form-${sectionId}`);
      if (!form) return;

      const input = form.querySelector('input[name="id"]');
      if (!input) return;

      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    updateVariantLabels() {
      this.querySelectorAll('.form__label').forEach((label) => {
        const valueSpan = label.querySelector('.form__label__value');
        const fieldset = label.closest('fieldset');
        if (!fieldset) return;

        const checked = fieldset.querySelector('input:checked');
        if (valueSpan && checked) valueSpan.textContent = checked.value;
      });
    }

    renderProductInfo() {
      const sectionId = this.dataset.section;

      fetch(
        `${window.location.pathname}?variant=${this.currentVariant.id}&section_id=${sectionId}`
      )
        .then((r) => r.text())
        .then((htmlText) => {
          const html = new DOMParser().parseFromString(htmlText, 'text/html');

          const priceDest = document.getElementById(`price-${sectionId}`);
          const priceSrc = html.getElementById(`price-${sectionId}`);
          if (priceDest && priceSrc) {
            priceDest.innerHTML = priceSrc.innerHTML;
            priceDest.classList.remove('visibility-hidden');
          }

          const invDest = document.querySelector('.product-inventory-notice');
          const invSrc = html.querySelector('.product-inventory-notice');
          if (invDest && invSrc) invDest.innerHTML = invSrc.innerHTML;

          const titleDest = document.querySelector('.product-title-container');
          const titleSrc = html.querySelector('.product-title-container');
          if (titleDest && titleSrc) titleDest.innerHTML = titleSrc.innerHTML;

          const skuDest = document.getElementById(`variant-sku-${sectionId}`);
          const skuSrc = html.getElementById(`variant-sku-${sectionId}`);
          if (skuDest && skuSrc) skuDest.innerHTML = skuSrc.innerHTML;

          this.toggleAddButton(
            !this.currentVariant.available,
            this.currentVariant.available
              ? window.variantStrings?.addToCart || 'Aggiungi al carrello'
              : window.variantStrings?.soldOut || 'Esaurito'
          );
        })
        .catch(() => {
          // se la fetch fallisce, non blocchiamo l'esperienza
        });
    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState(
        {},
        '',
        `${this.dataset.url}?variant=${this.currentVariant.id}`
      );
    }

updateMedia() {
  const sectionId = this.dataset.section;

  if (
    window.EncaptureVariantMetafieldGallery &&
    this.currentVariant?.id &&
    window.EncaptureVariantMetafieldGallery.update(sectionId, this.currentVariant.id)
  ) {
    return;
  }

  if (!this.currentVariant?.featured_media) return;

  const mediaId = this.currentVariant.featured_media.id;

  const selectorFull = `[data-media-id="${sectionId}-${mediaId}"]`;
  const selectorShort = `[data-media-id="${mediaId}"]`;

  const slider =
    document.querySelector('product-slider-thumbnails#Product-Slider') ||
    document.querySelector('#Product-Slider') ||
    document.querySelector('.product-images .flickity-enabled');

  if (!slider || typeof Flickity === 'undefined') return;

  const flkty = Flickity.data(slider);
  if (!flkty || !flkty.cells?.length) return;

  const index = flkty.cells.findIndex((cell) => {
    const el = cell.element;
    return (
      el.matches(selectorFull) ||
      el.matches(selectorShort) ||
      el.querySelector(selectorFull) ||
      el.querySelector(selectorShort)
    );
  });

  if (index < 0) return;

  flkty.options.draggable = false;
  flkty.updateDraggable();
  flkty.select(index, false, true);

  try {
    flkty.resize();
    flkty.reposition();
  } catch (e) {}
}

    toggleAddButton(disable = true, text) {
      const form = document.getElementById(`product-form-${this.dataset.section}`);
      if (!form) return;

      const btn = form.querySelector('[name="add"]');
      if (!btn) return;

      const span = btn.querySelector('span');

      if (disable) {
        btn.setAttribute('disabled', 'disabled');
        if (text && span) span.textContent = text;
      } else {
        btn.removeAttribute('disabled');
        if (span) span.textContent = window.variantStrings?.addToCart || 'Aggiungi al carrello';
      }
    }

    setUnavailable() {
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (price) price.classList.add('visibility-hidden');
    }
  }

  customElements.define('variant-selects', VariantSelects);
}

/* ---------------- CART AJAX ADD + DRAWER + SCROLL UNLOCK ---------------- */

(() => {
  if (window.__encaptureCartAjaxAddBound) return;
  window.__encaptureCartAjaxAddBound = true;

  const getCartDrawer = () =>
    document.getElementById('Cart-Drawer') ||
    document.querySelector('cart-drawer') ||
    document.querySelector('.side-panel.cart-drawer') ||
    null;

  const isDrawerOpen = (drawer) => {
    if (!drawer) return false;
    return (
      drawer.classList.contains('active') ||
      drawer.getAttribute('open') !== null ||
      drawer.getAttribute('aria-hidden') === 'false'
    );
  };

  const openDrawer = (drawer) => {
    if (!drawer) return;

    try {
      if (typeof drawer.open === 'function') {
        drawer.open();
        return;
      }
    } catch (e) {}

    drawer.classList.add('active');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('open-cc');
  };

  const unlockScroll = () => {
    const anyPanelOpen =
      document.querySelector('.side-panel.active') ||
      document.querySelector('cart-drawer.active, cart-drawer[open]') ||
      document.querySelector('#Cart-Drawer.active, #Cart-Drawer[open]');

    if (!anyPanelOpen) {
      document.body.classList.remove('open-cc', 'open-cc--product');
    }

    document.body.classList.remove('overflow-hidden', 'open-quick-view', 'open-product');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  };

  const refreshHeaderCount = () => {
    fetch(window.location.pathname + '?section_id=header')
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newCount = doc.querySelector('.thb-item-count');
        const oldCount = document.querySelector('.thb-item-count');
        if (newCount && oldCount) oldCount.textContent = newCount.textContent;
      })
      .catch(() => {});
  };

  const refreshDrawerContents = (drawer) => {
    return fetch(window.location.pathname + '?section_id=cart-drawer')
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const newCartDrawer = doc.querySelector('cart-drawer');
        if (newCartDrawer && drawer.tagName?.toLowerCase() === 'cart-drawer') {
          drawer.innerHTML = newCartDrawer.innerHTML;
          return;
        }

        const newInner =
          doc.querySelector('#Cart-Drawer') ||
          doc.querySelector('#CartDrawer') ||
          doc.querySelector('.cart-drawer');

        if (!newInner) return;

        const currentInner =
          drawer.querySelector?.('#Cart-Drawer') ||
          drawer.querySelector?.('#CartDrawer') ||
          drawer.querySelector?.('.cart-drawer') ||
          drawer;

        if (currentInner) currentInner.innerHTML = newInner.innerHTML;
      })
      .catch(() => {});
  };

  const rebindDrawerBehaviors = () => {
    try {
      if (typeof window.encaptureCartDrawerRebind === 'function') {
        window.encaptureCartDrawerRebind();
      }
    } catch (e) {}
  };

  // -------- QUICK VIEW / PRODUCT DRAWER: chiusura COMPLETA (pannello + immagini) --------

  const getProductPanelFromForm = (form) => {
    if (!form?.closest) return null;
    return form.closest(
      '#Product-Drawer, product-drawer, .side-panel.product-drawer, .product-drawer, .product-quick-view'
    );
  };

  const closeQuickImagesContainers = (scopeEl) => {
    const list = new Set();

    // 1) se il form sta dentro un container immagini
    if (scopeEl?.closest) {
      const near = scopeEl.closest('.product-quick-images--container');
      if (near) list.add(near);
    }

    // 2) se il pannello prodotto contiene un container immagini
    if (scopeEl?.querySelector) {
      const inside = scopeEl.querySelector('.product-quick-images--container');
      if (inside) list.add(inside);
    }

    // 3) qualsiasi container immagini rimasto attivo in pagina
    document.querySelectorAll('.product-quick-images--container.active').forEach((el) => list.add(el));

    list.forEach((el) => {
      el.classList.remove('active');
      el.removeAttribute('open');
      el.setAttribute('aria-hidden', 'true');
    });
  };

  const closeProductPanel = (panelOrForm) => {
    if (!panelOrForm) return;

    // prima chiudi SEMPRE i container immagini (sono quelli che ti restavano appesi)
    closeQuickImagesContainers(panelOrForm);

    // poi chiudi il pannello vero e proprio
    const panel =
      panelOrForm.matches?.('#Product-Drawer, product-drawer, .side-panel.product-drawer, .product-drawer, .product-quick-view')
        ? panelOrForm
        : panelOrForm.closest?.('#Product-Drawer, product-drawer, .side-panel.product-drawer, .product-drawer, .product-quick-view');

    if (panel) {
      try {
        if (typeof panel.close === 'function') panel.close();
      } catch (e) {}

      panel.classList.remove('active');
      panel.removeAttribute('open');
      panel.setAttribute('aria-hidden', 'true');
    }

    // togli solo classi "prodotto", NON toccare open-cc (serve al cart drawer)
    document.body.classList.remove(
      'open-cc--product',
      'open-product',
      'open-quick-view',
      'open-product-drawer'
    );
  };

  // ------------------- Intercetta SOLO add-to-cart -------------------

  document.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;

      const actionAttr = (form.getAttribute('action') || '').toLowerCase();
      const actionFull = (form.action || '').toLowerCase();
      const isAddToCart = actionAttr.includes('/cart/add') || actionFull.includes('/cart/add');

      if (!isAddToCart) return;
      if (!form.querySelector('input[name="id"]')) return;

      e.preventDefault();

      const root =
        (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(root + 'cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then((r) => {
          if (!r.ok) throw new Error('cart/add failed');
          return r.json();
        })
        .then(() => {
          // ✅ se arriva da quick view / product drawer, chiudi TUTTO e torna al cart drawer
          const productPanel =
            getProductPanelFromForm(form) ||
            document.querySelector('#Product-Drawer.active, product-drawer[open], .side-panel.product-drawer.active, .product-drawer.active, .product-quick-view.active');

          closeProductPanel(productPanel || form);

          const drawer = getCartDrawer();
          refreshHeaderCount();

          if (!drawer) return;

          return refreshDrawerContents(drawer).finally(() => {
            rebindDrawerBehaviors();
            openDrawer(drawer);
            window.dispatchEvent(new Event('resize'));
          });
        })
        .catch((error) => {
          console.error('Errore POST carrello:', error);
        });
    },
    true
  );

  /* ---- SCROLL UNLOCK FAILSAFE (chiusura drawer) ---- */

  document.addEventListener(
    'click',
    (e) => {
      if (e.target.closest('.side-panel-close, #wrapper .click-capture')) {
        setTimeout(() => {
          const drawer = getCartDrawer();
          if (!isDrawerOpen(drawer)) unlockScroll();
        }, 60);
      }
    },
    true
  );

  window.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    setTimeout(() => {
      const drawer = getCartDrawer();
      if (!isDrawerOpen(drawer)) unlockScroll();
    }, 60);
  });

  const drawer = getCartDrawer();
  if (drawer && !drawer.__encaptureScrollObs) {
    drawer.__encaptureScrollObs = true;
    const obs = new MutationObserver(() => {
      if (!isDrawerOpen(drawer)) unlockScroll();
    });
    obs.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'open', 'aria-hidden', 'style']
    });
  }

  if (!window.__encaptureBodyObsBound) {
    window.__encaptureBodyObsBound = true;
    const bodyObs = new MutationObserver(() => {
      const drawerNow = getCartDrawer();
      if (document.body.classList.contains('open-cc') && !isDrawerOpen(drawerNow)) {
        unlockScroll();
      }
    });
    bodyObs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
})();


/* ---------------- FLICKITY: KILL HORIZONTAL SWIPE (PRODUCT ONLY) ---------------- */

document.addEventListener('DOMContentLoaded', () => {
  const slider =
    document.querySelector('product-slider-thumbnails#Product-Slider') ||
    document.querySelector('#Product-Slider') ||
    document.querySelector('.product-images .flickity-enabled');

  if (!slider) return;

  const tryKillSwipe = () => {
    if (typeof Flickity === 'undefined') return;
    const flkty = Flickity.data(slider);
    if (!flkty) return;
    flkty.options.draggable = false;
    flkty.updateDraggable();
  };

  setTimeout(tryKillSwipe, 300);
  setTimeout(tryKillSwipe, 1000);

  // Se l’utente scorre in verticale, non blocchiamo.
  // Se prova a swipare orizzontale sull’area foto, preveniamo.
  let startX = 0;
  let startY = 0;

  slider.addEventListener(
    'touchstart',
    (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    },
    { passive: true }
  );

  slider.addEventListener(
    'touchmove',
    (e) => {
      const dx = Math.abs(e.touches[0].clientX - startX);
      const dy = Math.abs(e.touches[0].clientY - startY);
      if (dx > dy) e.preventDefault();
    },
    { passive: false }
  );
});

/* ---------------- ENCAPTURE — VARIANT METAFIELD GALLERY ---------------- */

(() => {
  if (window.EncaptureVariantMetafieldGallery) return;

  const instances = new Map();

  const setImage = (img, src, alt) => {
    if (!img) return;
    img.src = src || '';
    if (alt) img.alt = alt;
  };

  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.variantGalleryReady === '1') return null;

    const sectionId = gallery.dataset.sectionId;
    const jsonScript = gallery.querySelector('[data-variant-gallery-json]');
    if (!sectionId || !jsonScript) return null;

    let data = {};
    try {
      data = JSON.parse(jsonScript.textContent || '{}');
    } catch (e) {
      console.error('Encapture gallery JSON error:', e);
      return null;
    }

    const mainImage = gallery.querySelector('[data-gallery-main-image]');
    const zoomLink = gallery.querySelector('[data-gallery-zoom]');

    const thumbs = {
      1: gallery.querySelector('[data-gallery-thumb][data-gallery-index="1"]'),
      2: gallery.querySelector('[data-gallery-thumb][data-gallery-index="2"]'),
      3: gallery.querySelector('[data-gallery-thumb][data-gallery-index="3"]')
    };

    const thumbImgs = {
      1: gallery.querySelector('[data-gallery-thumb-image="1"]'),
      2: gallery.querySelector('[data-gallery-thumb-image="2"]'),
      3: gallery.querySelector('[data-gallery-thumb-image="3"]')
    };

    const mobileImgs = {
      1: gallery.querySelector('[data-gallery-mobile-image="1"]'),
      2: gallery.querySelector('[data-gallery-mobile-image="2"]'),
      3: gallery.querySelector('[data-gallery-mobile-image="3"]')
    };
const hideIfBroken = (img, index) => {
  if (!img) return;
  img.addEventListener('error', () => {
    const thumb = gallery.querySelector(`[data-gallery-thumb][data-gallery-index="${index}"]`);
    if (thumb) thumb.hidden = true;
    img.hidden = true;
  });
};

const hideIfAlreadyBroken = (img, index) => {
  if (!img) return;
  const thumb = gallery.querySelector(`[data-gallery-thumb][data-gallery-index="${index}"]`);
  if (img.complete && img.naturalWidth === 0) {
    if (thumb) thumb.hidden = true;
    img.hidden = true;
  }
};

hideIfBroken(thumbImgs[2], '2');
hideIfBroken(thumbImgs[3], '3');
hideIfBroken(mobileImgs[2], '2');
hideIfBroken(mobileImgs[3], '3');

hideIfAlreadyBroken(thumbImgs[2], '2');
hideIfAlreadyBroken(thumbImgs[3], '3');
hideIfAlreadyBroken(mobileImgs[2], '2');
hideIfAlreadyBroken(mobileImgs[3], '3');

const state = {
  variantId: gallery.dataset.currentVariantId || null,
  imageIndex: '1'
};

    const setSelectedThumb = (index) => {
      Object.values(thumbs).forEach((thumb) => thumb && thumb.classList.remove('is-selected'));
      const selected = thumbs[index] || thumbs[1];
      if (selected) selected.classList.add('is-selected');
    };

    const getVariantData = () => data[String(state.variantId)] || null;

    const applyMainImage = (index) => {
      const item = getVariantData();
      if (!item) return false;

      const can2 = !!item.has_extra_1 && !!(item.extra_1 || item.extra_1_thumb);
      const can3 = !!item.has_extra_2 && !!(item.extra_2 || item.extra_2_thumb);

      let safe = '1';
      if (String(index) === '2' && can2) safe = '2';
      if (String(index) === '3' && can3) safe = '3';

      const src =
        safe === '1' ? item.main :
        safe === '2' ? item.extra_1 :
        item.extra_2;

      const zoom =
        safe === '1' ? (item.main_zoom || item.main) :
        safe === '2' ? item.extra_1 :
        item.extra_2;

      setImage(mainImage, src, item.alt || '');
      if (zoomLink) zoomLink.href = zoom || src || '#';

      state.imageIndex = safe;
      setSelectedThumb(safe);
      return true;
    };

const updateVariant = (variantId) => {
  const item = data[String(variantId)];
  if (!item) return false;

  state.variantId = String(variantId);
  gallery.dataset.currentVariantId = String(variantId);

  const has2 = !!item.has_extra_1 && !!(item.extra_1 || item.extra_1_thumb || item.extra_1_mobile);
  const has3 = !!item.has_extra_2 && !!(item.extra_2 || item.extra_2_thumb || item.extra_2_mobile);
  const hasAnyExtra = has2 || has3;

  const thumbsWrapper = gallery.querySelector('[data-gallery-thumbs]');

  const showEl = (el) => {
    if (!el) return;
    el.hidden = false;
    el.removeAttribute('hidden');
    el.style.removeProperty('display');
    el.style.removeProperty('visibility');
    el.style.removeProperty('width');
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
  };

  const hideEl = (el) => {
    if (!el) return;
    el.hidden = true;
    el.setAttribute('hidden', '');
    el.style.setProperty('display', 'none', 'important');
  };

  /* MAIN THUMB */
  setImage(thumbImgs[1], item.main_thumb || item.main, item.alt);
  setImage(mobileImgs[1], item.main_mobile || item.main, item.alt);

  if (hasAnyExtra) {
    showEl(thumbsWrapper);
    showEl(thumbs[1]);
    showEl(thumbImgs[1]);
  } else {
    hideEl(thumbsWrapper);
  }

  /* EXTRA IMAGE 1 */
  if (has2) {
    setImage(thumbImgs[2], item.extra_1_thumb || item.extra_1, item.alt);
    setImage(mobileImgs[2], item.extra_1_mobile || item.extra_1, item.alt);

    showEl(thumbs[2]);
    showEl(thumbImgs[2]);
    showEl(mobileImgs[2]);
  } else {
    setImage(thumbImgs[2], '', item.alt);
    setImage(mobileImgs[2], '', item.alt);

    hideEl(thumbs[2]);
    hideEl(thumbImgs[2]);
    hideEl(mobileImgs[2]);
  }

  /* EXTRA IMAGE 2 */
  if (has3) {
    setImage(thumbImgs[3], item.extra_2_thumb || item.extra_2, item.alt);
    setImage(mobileImgs[3], item.extra_2_mobile || item.extra_2, item.alt);

    showEl(thumbs[3]);
    showEl(thumbImgs[3]);
    showEl(mobileImgs[3]);
  } else {
    setImage(thumbImgs[3], '', item.alt);
    setImage(mobileImgs[3], '', item.alt);

    hideEl(thumbs[3]);
    hideEl(thumbImgs[3]);
    hideEl(mobileImgs[3]);
  }

  return applyMainImage('1');
};

    gallery.addEventListener('click', (event) => {
      const thumb = event.target.closest('[data-gallery-thumb]');
      if (!thumb || !gallery.contains(thumb)) return;
      event.preventDefault();
      applyMainImage(thumb.dataset.galleryIndex || '1');
    });

    const api = { update: updateVariant };

    gallery.dataset.variantGalleryReady = '1';
    instances.set(sectionId, api);

    if (state.variantId) updateVariant(state.variantId);

    return api;
  };

  const initAll = () => {
    document.querySelectorAll('.encapture-variant-gallery').forEach(initGallery);
  };

  window.EncaptureVariantMetafieldGallery = {
    initAll,
    update(sectionId, variantId) {
      initAll();
      let instance = instances.get(sectionId);

      if (!instance) {
        const gallery = document.querySelector(
          `.encapture-variant-gallery[data-section-id="${sectionId}"]`
        );
        instance = initGallery(gallery);
      }

      if (!instance) return false;
      return instance.update(variantId);
    }
  };

  document.addEventListener('DOMContentLoaded', initAll);
})();
/* ---------------- ENCAPTURE — MOBILE SWATCH TOUCH + EMPTY METAFIELD FRAME FIX ---------------- */

(() => {
  if (window.__encaptureMobileSwatchAndGalleryFix) return;
  window.__encaptureMobileSwatchAndGalleryFix = true;

  function forceHide(el) {
    if (!el) return;
    el.hidden = true;
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.style.setProperty('width', '0', 'important');
    el.style.setProperty('height', '0', 'important');
    el.style.setProperty('overflow', 'hidden', 'important');
  }

  function forceShow(el) {
    if (!el) return;
    el.hidden = false;
    el.style.removeProperty('display');
    el.style.removeProperty('visibility');
    el.style.removeProperty('width');
    el.style.removeProperty('height');
    el.style.removeProperty('overflow');
  }

  function cleanEmptyGalleryFrames(scope) {
    const root = scope || document;

    root.querySelectorAll('.encapture-variant-gallery').forEach((gallery) => {
      const thumbsWrapper = gallery.querySelector('[data-gallery-thumbs]');
      const thumb2 = gallery.querySelector('[data-gallery-thumb][data-gallery-index="2"]');
      const thumb3 = gallery.querySelector('[data-gallery-thumb][data-gallery-index="3"]');
      const thumbImg2 = gallery.querySelector('[data-gallery-thumb-image="2"]');
      const thumbImg3 = gallery.querySelector('[data-gallery-thumb-image="3"]');
      const mobileImg2 = gallery.querySelector('[data-gallery-mobile-image="2"]');
      const mobileImg3 = gallery.querySelector('[data-gallery-mobile-image="3"]');

      const hasThumb2 = thumbImg2 && thumbImg2.getAttribute('src') && !thumb2?.hidden;
      const hasThumb3 = thumbImg3 && thumbImg3.getAttribute('src') && !thumb3?.hidden;

      if (!hasThumb2 && thumb2) forceHide(thumb2);
      if (!hasThumb3 && thumb3) forceHide(thumb3);

      if (thumbImg2 && !thumbImg2.getAttribute('src')) forceHide(thumbImg2);
      if (thumbImg3 && !thumbImg3.getAttribute('src')) forceHide(thumbImg3);

      if (mobileImg2 && !mobileImg2.getAttribute('src')) forceHide(mobileImg2);
      if (mobileImg3 && !mobileImg3.getAttribute('src')) forceHide(mobileImg3);

      if (thumbsWrapper && !hasThumb2 && !hasThumb3) {
        forceHide(thumbsWrapper);
      } else if (thumbsWrapper) {
        forceShow(thumbsWrapper);
      }
    });
  }

  function activateSwatch(event) {
    const label = event.target.closest(
      'variant-selects .product-form__input--color label, variant-selects .product-form__input--block label'
    );

    if (!label) return;

    const inputId = label.getAttribute('for');
    if (!inputId) return;

    const input = document.getElementById(inputId);
    if (!input || input.disabled) return;

    const variantSelects = input.closest('variant-selects');
    if (!variantSelects) return;

    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    setTimeout(() => {
      cleanEmptyGalleryFrames(document);
    }, 80);

    setTimeout(() => {
      cleanEmptyGalleryFrames(document);
    }, 350);
  }

  document.addEventListener('touchend', activateSwatch, true);
  document.addEventListener('click', activateSwatch, true);

  document.addEventListener(
    'error',
    function (event) {
      const img = event.target;
      if (!(img instanceof HTMLImageElement)) return;
      if (!img.closest('.encapture-variant-gallery')) return;

      const thumb = img.closest('.encapture-variant-gallery__thumb');
      if (thumb) forceHide(thumb);

      forceHide(img);

      const gallery = img.closest('.encapture-variant-gallery');
      cleanEmptyGalleryFrames(gallery);
    },
    true
  );

  document.addEventListener('DOMContentLoaded', function () {
    cleanEmptyGalleryFrames(document);
    setTimeout(() => cleanEmptyGalleryFrames(document), 500);
    setTimeout(() => cleanEmptyGalleryFrames(document), 1500);
  });

  window.addEventListener('load', function () {
    cleanEmptyGalleryFrames(document);
  });
})();